export default {
	"forepartner": {
		"addPartner": "e添加伙伴",
		"forepartner": "e添加成功"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/forepartner/forepartner.js